import { useGlobalAction } from "@gadgetinc/react";
import { message } from "antd";
import { api } from "../../../../api";
import { Button } from "../../../../externalComponents/tailwind/button";
import {
  Dialog,
  DialogActions,
  DialogBody,
  DialogTitle,
} from "../../../../externalComponents/tailwind/dialog";

export default function DeleteCouponDialog({
  open,
  onClose,
  category,
  onSuccess,
}) {
  const [{ fetching: isLoading }, deleteCoupons] = useGlobalAction(
    api.settings.deleteCouponCodes,
  );

  const handleDelete = async () => {
    try {
      const params = {};
      
      if (category) {
        params.category = category;
      }

      const result = await deleteCoupons(params);

      if (result.data?.success) {
       if (category) {
          message.success(
            `Deleted ${result.data.deletedCount} coupon codes from category "${category}"`,
          );
        }
        onSuccess();
      } else if (result.error) {
        message.error("Failed to delete: " + result.error.message);
      }
    } catch (error) {
      message.error("Failed to delete: " + error.message);
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Delete coupon{category ? " category" : ""}</DialogTitle>
      <DialogBody>
        {category ? (
          <p>
            Are you sure you want to delete all coupon codes in the category{" "}
            <b>{category}</b>? This action cannot be undone.
          </p>
        ) : null}
      </DialogBody>
      <DialogActions>
        <Button color="secondaryButton" onClick={onClose} disabled={isLoading}>
          Cancel
        </Button>
        <Button color="red" onClick={handleDelete} loading={isLoading}>
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
}
